/* global global */

// Third-party imports

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import { postGiftToCart } from '../../util/postGift.js';

import * as gc_featured_datalayer from '../../gift_catalogue/datalayer/gc_featuredproduct.js';
import * as gc_tabbed_datalayer from '../../gift_catalogue/datalayer/gc_tabbedproduct.js';

import * as gtm_vars from '../../../component/datalayer/gtm/gtm_vars.js';
import * as gtm_push from '../../../component/datalayer/gtm/gtm_push.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as product_datalayer from './datalayer.js';
import * as tealium from '../../datalayer/tealium.js';
import * as featured_card_handler from '../../gift_catalogue/card/featured_card_handler.js';
import * as tabbed_card_handler from '../../gift_catalogue/card/tabbed_card_handler.js';
import { get_product_site_schema } from '../../site_schema/site_schema.js';

import * as shopify_data from './shopify_data.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'product';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
    }

    product() {
        let data = this.data_element.dataset;

        shopify_data.save_product_data(
            {
                id: data.product_id,
                title: data.product_title,

                // This is the price of the first variant
                variants: data.product_variants,

                img_url: data.product_img_url,
                ismonthly: data.product_ismonthly,
            },
            data.product_ispromo,

            // position
            '1',

            `Gifts/${data.product_collection_title}`
        );
    }

    _click_variant(click_element) {
        let all_variant = click_element.querySelectorAll('.variant');
        let variants = [];
        for (let variant of all_variant) {
            let data = variant.dataset;

            variants.push({
                id: data.id,
                sku: data.sku,
                price: data.price,
            });
        }

        return variants;
    }

    click() {
        let click_element = this.data_element.querySelector('.click');
        let data = click_element.dataset;

        shopify_data.save_buttonclick_data(
            // product
            {
                id: data.product_id,
                name: data.product_name,
                category: `Gifts/${data.product_category}`,
                price: data.product_price,
                variant_size: data.product_variant_size,
                variants: this._click_variant(click_element),
            }
        );
    }

    run() {
        this.product();
        this.click();
    }
}

// OGC Product Page
function process_shopify_data(global) {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

    let data_element = global.document.getElementById('product-data');
    let shpdata = new ShopifyData(data_element);
    shpdata.run();

    // Product
    for (let d of SHOPIFY_DATA.product) {
        product_datalayer.update_product_datalayer(
            d.product,
            d.ispromo,
            d.position,
            d.collection_title
        );
    }

    // Button click
    product_datalayer.init_buttonclick_handler(global, SHOPIFY_DATA.click);
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.GiftCatalogue;
    PAGE_VARS.action = 'detail';
}

function store_gtm_product_view(global) {
    let data_element = global.document.getElementById('product-data');
    let dataset = data_element.dataset;

    global.productViews.push({
        item_name: dataset.product_title,
        item_id: dataset.product_id,
        price: dataset.product_price,
        item_category: dataset.product_collection_title,
        item_variant: dataset.product_variants,
        item_list_name: 'Gift Catalogue Products List',
    });

    global.uaProductViews.push({
        name: dataset.product_title,
        id: dataset.product_id,
        price: dataset.product_price,
        category: dataset.product_collection_title,
        variant: dataset.product_variants,
    });
}

function init_product_add_listener(global) {
    let button = global.document.getElementById('to_cart');
    button.addEventListener('click', () => {
        if (!button.classList.contains('button--disabled')) {
            on_add_to_cart_clicked(global);
        }
    });
}

function on_add_to_cart_clicked(global) {
    let form = global.document.getElementById('submitForm');
    postGiftToCart(global, form);
}

function initialize(global) {
    init_product_add_listener(global);
    process_shopify_data(global);
    store_gtm_product_view(global);
    get_product_site_schema(global, 'ogc');
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    let product_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };
    all_modules.push(
        product_mod,
        featured_card_handler,
        tabbed_card_handler,
        gtm_vars,
        gc_featured_datalayer,
        gc_tabbed_datalayer,
        gtm_push
    );

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
